import React from "react";
import { Box, Hidden } from "@mui/material";
// import { useStyles } from "./styles";
import "./SignUpLayout.scss";
import { Link } from "react-router-dom";
import { clientRoutes } from "src/utils/routes";
function SignUpLayout({ children }: any) {
  // const classes = useStyles();

  return (
    <Box
      className={`signup-layout-container`}
      sx={{
        width: "100%",
        position: "relative",
        backgroundPosition: "top",
        backgroundSize: "cover",
        display: "flex",
        alignItems: "start",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <Box
        className={`form-container`}
        sx={{
          background: "#FFFFFF",
          maxWidth: "386px",
          width: "100%",
          minHeight: 660,
          borderRadius: 8,
          margin: "10px",
          position: "relative",
          boxSizing: "border-box",
          // display: 'flex',
          flexDirection: "column",
          justifyContent: "space-between",
          paddingTop: "5%",
        }}
      >
        <Link to={clientRoutes.login} style={{ color: "inherit" }}>
          <Box sx={{ textAlign: "center" }}>
            <img
              src={"https://public.ticca.com/images/logo/Logo_Product.svg"}
              width={"150px"}
            />
          </Box>
        </Link>
        {children}
      </Box>
    </Box>
  );
}

export default SignUpLayout;
